{
  "home": {
    "meta": {
      "title": "MAJORITY - All-in-one mobile banking for migrants",
      "description": "Get an FDIC-insured account, Visa® Debit Card with discounts, no-fee money transfers and mobile top-ups, and cheap international calling!"
    },
    "hero": {
      "title": "All-in-one mobile banking for migrants",
      "body": "SAVE, SEND, SPEAK WITH THE MAJORITY APP",
      "cta": "Get Started"
    },
    "services": {
      "title": "What's included",
      "subtitle": "ALL THESE SERVICES IN ONE APP FOR ONLY ${appPrice}/MONTH!",
      "cta": "See full membership offer"
    },
    "account_content_box": {
      "tagline": "MAJORITY account",
      "title": "Get paid early!",
      "body": "Sign up for direct deposit and get paid up to two days early. Your MAJORITY account has all the features you need without the extra fees.\n* FDIC-insured\n* No minimum deposit\n* No minimum balance required"
    },
    "visa_content_box": {
      "tagline": "Visa® Debit Card**",
      "title": "Local community discounts",
      "body": "Get rewarded for supporting local. Check out our amazing discounts at local restaurants, grocery stores, and more. Shop with pride and save with the MAJORITY Visa® Debit Card.\n* No overdraft fees\n* No foreign transaction fees\n* Lock your card anytime"
    },
    "remittance_content_box": {
      "tagline": "Money transfers",
      "title": "COMPETITIVE RATES ON TRANSFERS",
      "body": "Send international money transfers the fast and secure way. It’s never been easier or more affordable to send money home.\n* Competitive exchange rates\n* No hidden fees\n* Fast, secure delivery"
    },
    "community_content_box": {
      "title": "Community driven",
      "body": "MAJORITY is built by migrants, for migrants. We know how hard it is to move to a new place, so we’re bringing a bit of home to you. All of the MAJORITY services and features were built with your needs in mind.\nYour MAJORITY membership also connects you with others in your community. Read inspirational stories and migrant resources about adjusting to life in the US. Plus, get exclusive access to events, local discounts, and more in your neighborhood!",
      "cta": "Connect with the community"
    },
    "mtu_content_box": {
      "tagline": "Mobile top-ups",
      "title": "Instant, no-fee top-ups",
      "body": "Recargas. Airtime. Mobile top-ups. Whatever you call it, you can top up anyone back home for less with MAJORITY.\n* No fees to send\n* Instant, secure delivery\n* Special promotions to Cuba and more"
    },
    "calling_content_box": {
      "tagline": "International calling",
      "title": "Unlimited, free calling to 20+ countries",
      "body": "Make unlimited, free calls to Mexico, Colombia, Canada, the UK, and 20+ other countries. Call Nigeria, Cuba, and anywhere else in the world at the lowest rates with high-quality connections.\n* Call any mobile or landline phone\n* High-quality connections\n* No internet required"
    },
    "advisor_content_box": {
      "tagline": "Personalized advisor",
      "title": "An advisor just for you",
      "body": "We speak your language. Meet a personalized advisor who can answer your questions in your own language. Plus, as part of our community, get access to exclusive content, tips, and events.\n* Personalized customer support\n* Community resources and stories\n* Invitation to community events"
    }
  }
}